import { RouteLoadingScreen as SharedRouteLoadingScreen } from '@invento/ui/components/route-loading-screen';

interface RouteLoadingScreenProps {
  contained?: boolean;
  label?: string;
  visible?: boolean;
  delayMs?: number;
  minVisibleMs?: number;
}

export function RouteLoadingScreen({ contained = false, label = 'Loading page', ...props }: RouteLoadingScreenProps) {
  return <SharedRouteLoadingScreen contained={contained} label={label} {...props} />;
}
